// Alias
import Radio from '../radio/index';
export default Radio;
//# sourceMappingURL=radio.js.map